import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import dynamic from "next/dynamic";
import { BannerBackground, BannerBackgroundSwirlWrapper, BannerPromoText } from "./Banner.styles";
var BannerBackgroundSwirl = dynamic(function() {
    return import("./BannerBackground").then(function(module) {
        return module.BannerBackgroundSwirl;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                require.resolveWeak("./BannerBackground")
            ];
        }
    }
});
export var Banner = function(param) {
    var children = param.children, title = param.title;
    return /*#__PURE__*/ _jsxs(BannerBackground, {
        children: [
            /*#__PURE__*/ _jsx(BannerPromoText, {
                children: title
            }),
            children,
            /*#__PURE__*/ _jsx(BannerBackgroundSwirlWrapper, {
                children: /*#__PURE__*/ _jsx(BannerBackgroundSwirl, {})
            })
        ]
    });
};
